<template>
  <div :id="cardId" :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en']" class="test">
    <div :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '', 'info-card']">
      <div :class="[this.$lang === 'ar' ? 'right-dir' : 'left-dir', 'text']">
        <div :class="[this.$lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en', 'titles']">
          <img class="info-icon" src="../../assets/icons/info.svg">
          {{ title }}
        </div>
        <div :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en', 'type']">{{ info }}</div>
      </div>
      <div @click="handleAnimation" class="mobile-arrow-container" :class="isOpen ? 'rotate' : ''"><img
          class="mobile-arrow" src="../../assets/icons/down-white-arrow.svg"></div>
      <div @click="handleAnimation" :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '', 'button']">
        <div :class="[this.$lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en', 'btn-title']">{{ btn }}</div>
        <div :class="[this.$lang === 'ar' ? 'px-3' : 'px-3', 'arrow-container', isOpen ? 'rotate' : '']"><img
            src="../../assets/icons/white-arrow.svg" /></div>
      </div>
    </div>
    <div class="wrapper" :class="isOpen ? 'is-open' : ''">
      <!--    <div v-if="fail || !show" class="inner overflow-hidden">-->
      <!--      <div v-if="!show" style="height: 300px; display: flex; align-items: center; justify-content: center; flex-direction: column">-->
      <!--        <loader />-->
      <!--      </div>-->
      <!--      <error v-if="fail" />-->
      <!--    </div>-->
      <ul :class="[this.$lang === 'ar' ? 'right-dir' : 'left-dir', 'inner']">
        <div v-for="(item, i) in items" :key="i" class="liContainer">
          <li class="list mb-5" :id="item.id"><span class="tableHeader">
              <img src="../../assets/icons/blackCircle.svg" class="blackCircle display"
                style="padding: 0 5px; width: 15px; height: 15px">
              <img src="../../assets/icons/whiteCircle.svg" style="padding: 0 5px; width: 15px; height: 15px"
                class="whiteCircle">{{ item.name }}</span>
            <!--          <img src="../../assets/icons/plusIcon.svg" class="plusIcon" @click="toggleTable(item.id)"> <img src="../../assets/icons/minesIcon.svg" class="minIcon display" @click="closeTable(item.id)">-->
            <div class="circle-plus plusIcon closed" @click="toggleTable(item.id, i)">
              <div class="circle">
                <div class="horizontal"></div>
                <div class="vertical"></div>
              </div>
            </div>
            <div class="innerTable ">
              <table>
                <tr>
                  <th>
                    {{ neighboring }}
                  </th>
                  <th>
                    {{ rest }}
                  </th>
                  <th>
                    {{ satellite }}
                  </th>
                  <th>
                    {{ homeRate }}
                  </th>
                </tr>
                <tr>
                  <td>
                    {{ item.countyRate }}
                  </td>
                  <td>
                    {{ item.worldRate }}
                  </td>
                  <td>
                    {{ item.flightRate }}
                  </td>
                  <td>
                    {{ item.homeRate }}
                  </td>
                </tr>
              </table>
            </div>
          </li>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
// import Loader from '../LoaderBtn/Loader'
// import Error from '../errorHandle/Error'
export default {
  // components: { Error, Loader },
  props: {
    data: Array,
    load: Boolean,
    error: Boolean,
    open: String,
    name: String,
    list: Array
  },
  watch: {
    data (val) {
      this.items = [...val]
    },
    load (val) {
      if (val) {
        this.show = false
        this.fail = false
      } else {
        this.show = true
      }
    },
    error (val) {
      if (val) {
        this.fail = true
        this.show = true
      }
    },
    open (val) {
      this.cardId = val
    }
  },
  data () {
    return {
      lang: this.$lang,
      info: this.$t('products.addInfo.roamingText'),
      isOpen: false,
      items: [],
      btn: this.$store.state.window > 750 ? this.$t('roamingCountries.showButton') : this.$t('roamingCountries.smallShowButton'),
      show: false,
      fail: false,
      width: this.$store.state.window,
      cardId: '',
      title: '',
      tableOpen: false,
      plusIcon: 'plusIcon',
      mainID: '',
      neighboring: this.$store.state.window > 750 ? this.$t('roamingCountries.header1') : this.$t('roamingCountries.smallHeader1'),
      rest: this.$store.state.window > 750 ? this.$t('roamingCountries.header2') : this.$t('roamingCountries.smallHeader2'),
      satellite: this.$store.state.window > 750 ? this.$t('roamingCountries.header3') : this.$t('roamingCountries.smallHeader3'),
      homeRate: this.$store.state.window > 750 ? this.$t('roamingCountries.header4') : this.$t('roamingCountries.smallHeader4')
    }
  },
  created () {
    this.$watch(() => {
      return this.$store.state.productsInnerTab
    }, (val) => {
      this.info = this.$t('products.addInfo.roamingText')
    })
    this.$watch(() => {
      return this.$store.state.window
    }, (val) => {
      this.width = val
      if (val < 750) {
        this.btn = this.$t('roamingCountries.smallShowButton')
        this.neighboring = this.$t('roamingCountries.smallHeader1')
        this.rest = this.$t('roamingCountries.smallHeader2')
        this.satellite = this.$t('roamingCountries.smallHeader3')
        this.homeRate = this.$t('roamingCountries.smallHeader4')
      } else {
        this.btn = this.$t('roamingCountries.showButton')
        this.neighboring = this.$t('roamingCountries.header1')
        this.rest = this.$t('roamingCountries.header2')
        this.satellite = this.$t('roamingCountries.header3')
        this.homeRate = this.$t('roamingCountries.smallHeader4')
      }
      // this.btn = val > 500 ? this.$t('products.addInfo.btn') : this.$lang === 'ar' ? 'المزيد' : 'More'
    })
    this.$watch(() => {
      return this.mainID
    }, (val) => {
      this.mainID = val
    })
  },
  mounted () {
    this.cardId = this.open
    this.title = this.name
    this.items = this.list
    this.$watch(() => {
      return this.$store.state.window
    }, (val) => {
      this.width = val
      if (val < 750) {
        this.btn = this.$t('roamingCountries.smallShowButton')
      } else {
        this.btn = this.$t('roamingCountries.showButton')
      }
      // this.btn = val > 500 ? this.$t('products.addInfo.btn') : this.$lang === 'ar' ? 'المزيد' : 'More'
    })
    this.arabic()
    this.arabicRadio()
  },
  methods: {
    handleAnimation () {
      this.cardId = this.open
      // const id = this.cardId
      // const row = $('body').find('#' + this.cardId)
      if (!this.isOpen) {
        // $(row + '.wrapper').addClass('aliiiiiiiiiiiiii')
        // $('#' + this.cardId + ' ' + '.wrapper').addClass('is-open')
        // $('#' + this.cardId + ' ' + '.arrow-container').addClass('rotate')
        // $('#' + this.cardId + ' ' + '.mobile-arrow-container').addClass('rotate')
        // this.btn = this.$lang === 'ar' ? 'إخفاء' : this.width > 500 ? 'Show Less' : 'Less'
        this.isOpen = true
      } else {
        // $('#' + this.cardId + ' ' + '.wrapper').removeClass('is-open')
        // $('#' + this.cardId + ' ' + '.arrow-container').removeClass('rotate')
        // $('#' + this.cardId + ' ' + '.mobile-arrow-container').removeClass('rotate')
        // this.btn = this.$lang === 'ar' ? 'المزيد' : this.width > 500 ? 'Show More' : 'More'
        this.isOpen = false
      }
      this.arabic()
    },
    toggleTable (val, index) {
      this.mainID = val
      const lastItem = this.items.length - 1
      for (let i = 0; i < this.items.length; i++) {
        $('#' + this.items[i].id + ' ' + '.circle-plus').removeClass('opened')
        $('#' + this.items[i].id + ' ' + '.innerTable').removeClass('tableAnimation')
        $('#' + this.items[i].id).css('background', 'none')
        $('#' + this.items[i].id).removeClass('animationTest')
        $('#' + this.items[i].id + ' ' + '.whiteCircle').removeClass('display')
        $('#' + this.items[i].id + ' ' + '.blackCircle').addClass('display')
        $('#' + this.items[lastItem].id).css('margin-bottom', '30px')
        $('#' + this.items[i].id + ' ' + '.tableHeader').css('color', 'white')
        $('#' + this.items[i].id + ' ' + '.tableHeader').css('font-family', ' Mtn-regular')
        if (i !== index) {
          this.items[i].isOpened = false
        }
      }
      this.items[index].isOpened = !this.items[index].isOpened
      if (this.items[index].isOpened === true) {
        // this.items[index].isOpened = false
        $('#' + this.mainID + ' ' + '.circle-plus').addClass('opened')
        $('#' + this.mainID + ' ' + '.innerTable').addClass('tableAnimation')
        $('#' + this.mainID).css('background', 'rgb(255 255 255 / 70%)')
        $('#' + this.mainID).addClass('animationTest')
        $('#' + this.mainID + ' ' + '.whiteCircle').addClass('display')
        $('#' + this.mainID + ' ' + '.blackCircle').removeClass('display')
        $('#' + this.mainID + ' ' + '.tableHeader').css('color', 'black')
        $('#' + this.mainID + ' ' + '.tableHeader').css('font-family', ' Mtn-bold-italic')
        if (this.mainID === this.items[lastItem].id) {
          // console.log('mefh')
          $('#' + this.items[lastItem].id).addClass('lastItem')
        }
      } else if (this.items[index].isOpened === false) {
        $('#' + this.mainID + ' ' + '.circle-plus').removeClass('opened')
        $('#' + this.mainID + ' ' + '.innerTable').removeClass('tableAnimation')
        $('#' + this.mainID).css('background', 'none')
        $('#' + this.mainID).removeClass('animationTest')
        $('#' + this.mainID + ' ' + '.whiteCircle').removeClass('display')
        $('#' + this.mainID + ' ' + '.blackCircle').addClass('display')
        $('#' + this.mainID + ' ' + '.tableHeader').css('color', 'white')
        $('#' + this.mainID + ' ' + '.tableHeader').css('font-family', ' Mtn-regular')
        if (this.mainID === this.items[lastItem].id) {
          // console.log('mefh')
          $('#' + this.items[lastItem].id).removeClass('lastItem')
        }
      }
      // console.log('22', this.items[index].isOpened)
    },
    arabic () {
      if (this.lang === 'ar') {
        // console.log('hihih')
        $('.mainTitle, .contentTitle, #roaming-countries .titleName').css('font-family', 'Mtn-arabic-bold')
        $('ul li .plusIcon, ul li .minIcon').addClass('test22')
        $('#roaming-countries .social-nav').css('direction', 'rtl')
        $('.arrowIcon').css('transform', 'rotateY(180deg)')
        $('.returnBack').addClass('arabicBack')
        $('.mapContainer').css('direction', 'rtl')
        $('.checkContainer').css('direction', 'ltr')
        $('.list table').addClass('leftDir')
        $('.p-dropdown, .description2, #roaming-countries .bundleTitle').css('font-family', 'Mtn-arabic-regular')
        $('.description').css('font-family', 'Mtn-arabic-medium')
        $('.selectedName').css('font-family', 'Mtn-arabic-bold')
      } else {
      }
    },
    arabicRadio () {
      if (this.$lang === 'ar') {
        $('.post').css('font-family', 'Mtn-arabic-regular')
        $('.pre').css('font-family', 'Mtn-arabic-regular')
        $('.post').css('font-size', '10px')
        $('.pre').css('font-size', '10px')
        if ($('#pre').is(':checked')) {
          $('.pre').css('font-family', 'Mtn-arabic-bold')
          $('.pre').css('font-size', '10px')
          // $('.post').css('font-family', 'Mtn-arabic-regular')
          // $('.post').css('font-size', '11px')
        } else if ($('#post').is(':checked')) {
          $('.post').css('font-family', 'Mtn-arabic-bold')
          $('.post').css('font-size', '10px')
          // $('.pre').css('font-family', 'Mtn-arabic-regular')
          // $('.pre').css('font-size', '11px')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.innerTable {
  opacity: 0;
  transition: opacity 0.3s ease-out;
}

.tableAnimation {
  opacity: 1 !important;
}

.closed {
  .vertical {
    transition: all 0.3s ease-in-out;
    transform: rotate(-90deg);
  }

  .horizontal {
    transition: all 0.3s ease-in-out;
    transform: rotate(-90deg);
    opacity: 1;
  }
}

.opened {
  opacity: 1;

  .vertical {
    transition: all 0.3s ease-in-out;
    transform: rotate(90deg);
    background-color: black !important;
  }

  .horizontal {
    transition: all 0.3s ease-in-out;
    transform: rotate(90deg);
    opacity: 0;
    background-color: black !important;
  }
}

.circle-plus {
  /*height: 4em;*/
  /*width: 4em;*/
  margin: 0 45px;
  font-size: 1em;
  opacity: .7;
}

.circle-plus .circle {
  position: relative;
  width: 20px;
  height: 20px;
  border-radius: 10%;
  /*background:#898989;*/
}

.circle-plus .circle .horizontal {
  position: absolute;
  background-color: white;
  width: 12px;
  height: 2px;
  left: 20%;
  top: 45%;
}

.circle-plus .circle .vertical {
  position: absolute;
  background-color: white;
  width: 2px;
  height: 12px;
  left: 45%;
  top: 20%;
}

.lastItem {
  margin-bottom: 0px !important;
  border-radius: 0 0 36px 36px !important;
}

.open {
  padding: 0 !important;
}

.liOpen {
  padding: 0 75px !important;
}

.test22 {
  float: left !important;
}

.display {
  display: none;
}

.leftDir {
  direction: ltr !important;
}

.mobile-arrow-container {
  display: none;
}

.info-icon {
  display: none;
}

.rotate {
  transform: rotate(180deg) !important;
}

ali {
  float: left !important;
}

.test {
  width: 92%;
  background: #FFCB05 !important;
  margin: 0 auto;
  border-radius: 40px;
  border: 3px solid rgba(255, 255, 255, .7);
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 40px;
  text-align: initial;
  box-shadow: 15px 15px 40px rgba(0, 0, 0, .1);
}

.info-card {
  min-height: 150px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 3vw;
}

.button {
  width: 200px;
  height: 55px;
  color: #fff;
  border: 3px solid #fff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;

  .arrow-container {
    transition: all .3s ease-in-out;
  }
}

.titles {
  font-size: 22px;
  color: #fff;
  text-align: initial;
}

.wrapper {
  display: grid;
  grid-template-rows: 0fr;
  transition: all .3s ease-in-out;
}

.arabicBack {
  right: 4vw;
  left: unset;
  transform: rotateY(180deg);
}

ul {
  /*padding: 0 58px;*/
  color: #FFFFFF;
  overflow: hidden;
  margin-bottom: 0 !important;
  /*font-size: 13px;*/
}

li {
  width: max-content;
}

.is-open {
  grid-template-rows: 1fr !important;
}

@media (max-width: 680px) {
  .button {
    width: 160px !important;
  }

  .info-card {
    padding: 0 3vw !important;
  }

  .titles {
    font-size: 20px;
  }

  .type {
    font-size: 14px;
  }

  ul {
    padding: 0 40px !important;
  }

  li {
    word-wrap: break-word;
    width: 100%;
  }
}

@media (max-width: 550px) {
  .titles {
    text-decoration: underline;
    font-size: 19px;
  }

  .info-card {
    min-height: 130px;
    padding-top: 16px !important;
  }

  .button,
  .type {
    display: none;
  }

  .mobile-arrow-container {
    display: block;
    color: #fff;
    cursor: pointer;
    transition-duration: .3s;
    margin: 5px 10px 0px 0;
  }

  .mobile-arrow {
    height: 15px;
    width: 15px
  }

  .info-icon {
    display: initial;
    height: 30px;
    width: 30px;
    margin: 0 6px;
    margin-bottom: 5px;
  }

  .circle-plus {
    margin: 0 10px;
  }

  .tableHeader {
    padding: 0 10px;
  }
}

.list {
  width: 100%;
  padding: 20px 3vw !important;
  font-size: 15px;
  height: 60px;
  transition: height 0.3s ease-in-out, background-color 0.3s ease-out;
}

.animationTest {
  height: 275px !important;
}

.list table {
  width: 100%;
  /*border-radius: 1em;*/
  /*border-collapse: collapse;*/
  padding: 30px 0;
}

.list table tr {
  /*border: 1px solid black;*/
  /*border-collapse: collapse;*/
  height: 3.5rem;
}

table {
  border-collapse: separate;
  border-spacing: 0;
  min-width: 0px;
}

table tr th,
table tr td {
  border-right: 1px solid black;
  border-bottom: 1px solid black;
  padding: 5px;
  color: black;
  text-align: center;
}

table tr th:first-child,
table tr td:first-child {
  border-left: 1px solid black;
}

table tr th {
  /*background: #eee;*/
  border-top: 1px solid black;
  text-align: center;
  font-family: Mtn-bold-italic;
  width: 25%;
}

@media (max-width: 1030px) {
  table {
    font-size: 12px;
  }
}

/* top-left border-radius */
table tr:first-child th:first-child {
  border-top-left-radius: 15px;
}

/* top-right border-radius */
table tr:first-child th:last-child {
  border-top-right-radius: 15px;
}

/* bottom-left border-radius */
table tr:last-child td:first-child {
  border-bottom-left-radius: 15px;
}

/* bottom-right border-radius */
table tr:last-child td:last-child {
  border-bottom-right-radius: 15px;
}

.liContainer {
  width: 100%;
  /*padding: 0px 75px;*/
  /*<!--background: rgb(255 255 255 / 70%);-->*/
}

ul {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.plusIcon {
  float: right;
  margin-top: -7px;
  cursor: pointer;
}

.minIcon {
  float: right;
  margin-top: -7px;
  cursor: pointer;
}
</style>
<style lang="scss">
.test {
  .dot-spinner__dot::before {
    background-color: #F2F2F2 !important;
  }
}
</style>
